import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleSubscript } from 'roosterjs-editor-api';

const subscript: RibbonButton = {
    key: 'subscript',
    title: () => strings.subscript,
    imageSrc: require('../svg/subscript.svg'),
    buttonState: formatState =>
        formatState.isSubscript ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleSubscript(plugin.getEditor()),
};

export default subscript;
